'use strict';

var jsxRuntime = require('react/jsx-runtime');
var icons_Icon = require('./Icon.js');
require('react');
require('../_chunks/combineClasses-5P8GTQkg.js');
require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');

const IconOpenIn = icons_Icon.iconFactory('IconOpenIn', jsxRuntime.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", "data-icon-type": "fill", children: jsxRuntime.jsx("path", { d: "M5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V14.6667H17.3333V17.3333H6.66666V6.66667H9.33333V4H5ZM12.5 4C12.2239 4 12 4.22386 12 4.5V6.16667C12 6.44281 12.2239 6.66667 12.5 6.66667H15.4565L9.43402 12.6892C9.23876 12.8844 9.23876 13.201 9.43402 13.3963L10.6099 14.5722C10.8052 14.7675 11.1218 14.7675 11.317 14.5722L17.3333 8.55592V11.5C17.3333 11.7761 17.5572 12 17.8333 12H19.5C19.7761 12 20 11.7761 20 11.5L20 4H17.8333H12.5Z" }) }));

exports.IconOpenIn = IconOpenIn;
//# sourceMappingURL=IconOpenIn.js.map
